import React from "react";
import { useParams } from "react-router-dom";
import Header from "./common/Header";
import Footer from "./common/Footer";
import SEO from "./SEO";

const Contact = () => {
  const { locationId, templateId } = useParams();

  const locationName = locationId === "Rio-Linda" ? "Rio Linda" : "Rancho Cordova";
  const address = templateId === "1"
    ? "912 Oak Ln, Rio Linda, CA 95673"
    : "10423 Folsom Blvd, Rancho Cordova, CA 95670";
  const phone = templateId === "1" ? "(916) 991-9996" : "(916) 855-1111";

  return (
    <>
      <SEO
        title={`Contact Us - ${locationName} Location | Bowinkles Drive Thru`}
        description={`Contact Bowinkles Drive Thru ${locationName} location. Call us at ${phone} or visit us at ${address}. Find us on Yelp and Facebook.`}
        keywords={`Bowinkles ${locationName}, contact Bowinkles, ${locationName} restaurant, fast food ${locationName}, ${address}`}
        image="/images/bowinklesfoodcover.jpeg"
      />
      <div className="contactContainer">
        <div className="fluid-container">
          <Header />
        <div className="container formContainer">
          <div className="row text-center">
            {templateId === "1" ? (
              <>
                <div className="col-md-3 img-thumbnail m-4">
                  <h2 className="text-center py-2">Write a Google Review</h2>
                  <a
                    href="https://goo.gl/zoKp4Z"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-google fa-4x"></i>
                  </a>
                </div>
                <div className="col-md-3 img-thumbnail m-4">
                  <h2 className="text-center py-2">Write a Yelp Review</h2>
                  <a
                    href="https://www.yelp.com/biz/bowinkles-restaurant-rio-linda"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-yelp fa-4x"></i>
                  </a>
                </div>
                <div className="col-md-3 img-thumbnail m-4">
                  <h2 className="text-center py-2">Like on Facebook</h2>
                  <a
                    href="https://www.facebook.com/pages/Bowinkles/152251514818823"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-facebook-f fa-4x"></i>
                  </a>
                </div>
              </>
            ) : (
              <>
                <div className="col-md-3 img-thumbnail m-4">
                  <h2 className="text-center py-2">Write a Google Review</h2>
                  <a
                    href="https://goo.gl/zoKp4Z"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-google fa-4x pb-2"></i>
                  </a>
                </div>
                <div className="col-md-3 img-thumbnail m-4">
                  <h2 className="text-center py-2">Write a Yelp Review</h2>
                  <a
                    href="https://www.yelp.com/biz/bowinkle-drive-thru-rancho-cordova"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-yelp fa-4x pb-2"></i>
                  </a>
                </div>
                <div className="col-md-3 img-thumbnail m-4">
                  <h2 className="text-center py-2">Like on Facebook</h2>
                  <a
                    href="https://www.facebook.com/Bowinkle-Drive-Thru-Rancho-112045923495549/?rf=258331081514609"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-facebook-f fa-4x pb-2"></i>
                  </a>
                </div>
              </>
            )}
          </div>
        </div>
        <Footer />
      </div>
    </div>
    </>
  );
};

export default Contact;
